import { render, staticRenderFns } from "./WasteVisualization.vue?vue&type=template&id=5293b485&scoped=true&"
import script from "./WasteVisualization.vue?vue&type=script&lang=js&"
export * from "./WasteVisualization.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualization.vue?vue&type=style&index=0&id=5293b485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293b485",
  null
  
)

export default component.exports